import axios from '@/utils/fetch'
const context = '/mall';
const version = 'v1.0';
const prefixUri = `${context}/${version}/mobile`
const isLocalMock = false;
export default {

  /**
    //获取自定义页面详情
   * GET /v1.0/mobile/diy_page/{pid}
   * @post
   */
  diy_page(pid, option = undefined) {
    if (0 || option && option.isLocalMock || isLocalMock) {
      console.log('API mock diy_page');
      return new Promise(r => {
        r(
        )
      });
    } else {
      return axios({
        url: `${prefixUri}/diy_page/${pid}`,
        method: "GET",
        ...option
      })
    }
  },

  /**
    //获取基础页面详情
   * GET /v1.0/mobile/base_info/{pid}
   * @post
   */
  base_info(pid, option = undefined) {
    if (0 || option && option.isLocalMock || isLocalMock) {
      console.log('API mock base_info');
      return new Promise(r => {
        r(
        )
      });
    } else {
      return axios({
        url: `${prefixUri}/base_info/${pid}`,
        method: "GET",
        ...option
      })
    }
  },
}


// WEBPACK FOOTER //
// ./src/apis/src/pageH5.js